import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Input, Select, Button, Space, Typography, Spin } from 'antd'
import { SearchOutlined, ReloadOutlined, ShrinkOutlined } from '@ant-design/icons'
import KGVisualization from '../components/KGVisualization'
import KGOverview from '../components/KGOverview'
import { useKGStore } from '../stores/kgStore'

const { Title } = Typography
const { Option } = Select

const KGPage: React.FC = () => {
  const [searchType, setSearchType] = useState<string>('标准号')
  const [searchInput, setSearchInput] = useState<string>('')
  
  const { 
    overview, 
    subgraph, 
    loading,
    error,
    fetchOverview, 
    searchSubgraph,
    expandNode
  } = useKGStore()

  useEffect(() => {
    fetchOverview()
  }, [fetchOverview])

  const handleSearch = async () => {
    if (!searchInput.trim()) return
    
    try {
      await searchSubgraph(searchType, searchInput)
    } catch (error) {
      console.error('搜索失败:', error)
    }
  }

  const handleRefresh = () => {
    fetchOverview()
  }

  const handleCollapse = () => {
    // 收缩到初始状态
    setSearchInput('')
    searchSubgraph('标准号', '')
  }

  const handleNodeClick = async (node: any) => {
    if (!node || node.isCenter) return
    
    console.log('点击节点:', node)
    
    try {
      await expandNode(node.id, node.type, node.label)
    } catch (error) {
      console.error('节点扩展失败:', error)
    }
  }

  return (
    <div>
      <Row gutter={[24, 24]}>
        {/* 左侧：概览信息 */}
        <Col xs={24} lg={8}>
          <Card title="图谱概览" extra={
            <Button 
              icon={<ReloadOutlined />} 
              onClick={handleRefresh}
              size="small"
            >
              刷新
            </Button>
          }>
            <KGOverview data={overview} />
          </Card>
        </Col>

        {/* 右侧：搜索和可视化 */}
        <Col xs={24} lg={16}>
          <Card title="图谱查询与可视化">
            <Space direction="vertical" style={{ width: '100%' }} size="large">
              {/* 搜索区域 */}
              <Row gutter={[16, 16]} align="middle">
                <Col flex="auto">
                  <Input.Group compact>
                    <Select
                      value={searchType}
                      onChange={setSearchType}
                      style={{ width: '120px' }}
                    >
                      <Option value="标准号">标准号</Option>
                      <Option value="机构名称">机构名称</Option>
                      <Option value="起草人">起草人</Option>
                    </Select>
                    <Input
                      placeholder={`请输入${searchType}`}
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onPressEnter={handleSearch}
                      style={{ flex: 1 }}
                    />
                  </Input.Group>
                </Col>
                <Col>
                  <Space>
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={handleSearch}
                      loading={loading}
                    >
                      查询
                    </Button>
                    <Button
                      icon={<ShrinkOutlined />}
                      onClick={handleCollapse}
                      disabled={!subgraph}
                    >
                      收缩
                    </Button>
                  </Space>
                </Col>
              </Row>

              {/* 可视化区域 */}
              <div style={{ height: '600px', border: '1px solid #d9d9d9', borderRadius: '6px' }}>
                {loading ? (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%' 
                  }}>
                    <Spin size="large" />
                  </div>
                ) : error ? (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%',
                    color: '#ff4d4f',
                    flexDirection: 'column'
                  }}>
                    <div style={{ fontSize: '16px', marginBottom: '8px' }}>❌</div>
                    <div>{error}</div>
                  </div>
                ) : (
                  <KGVisualization data={subgraph} onNodeClick={handleNodeClick} />
                )}
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default KGPage
